import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {EventLink} from '../../styled-components/event-link'
import {ShareButtonProps} from './interfaces'

export const ShareButton = ({event}: ShareButtonProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()

  const mobile = useMembersPageSelector(isMobile)

  const {shareEvent, shareEventOld} = useMembersPageActions()

  return (
    <EventLink
      mobile={mobile}
      onClick={() =>
        experiments.enabled(ExperimentNames.UseEventsViewerReduxToolkit)
          ? shareEvent({event, returnFocusElement: hookToAttributeSelector(DH.BUTTON_SHARE)})
          : shareEventOld({event, returnFocusElement: hookToAttributeSelector(DH.BUTTON_SHARE)})
      }
      data-hook={DH.BUTTON_SHARE}
      textButton
    >
      {t('events.buttons.share-event')}
    </EventLink>
  )
}
